<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_label_search_template') ||
                  '模板编号/模板名称/模板文件名称 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
      :modal-append-to-body="false"
      :modal="false"
    >
      <el-form ref="form" :model="form" label-width="140px" size="small">
        <el-row :gutter="20">
          <el-col :span="24" v-if="!templateStatus || !templateStatus.length">
            <el-form-item :label="$l('INDEX.Status') || '有效状态'">
              <el-checkbox-group v-model="form.templateStatusList" size="small">
                <el-checkbox label="Y">
                  {{ $l('form_label_enabled') || '已启用' }}
                </el-checkbox>
                <el-checkbox label="N">
                  {{ $l('form_label_not_enabled') || '未启用' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('table_label_templateNo') || '模板编号'">
              <el-input v-model.trim="form.templateNo" clearable size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_templateName') || '模板名称'">
              <el-input v-model.trim="form.templateName" clearable size="small">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_templateFileType') || '模版文件类型'"
            >
              <el-input
                v-model.trim="form.templateFileType"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_templateFileName') || '模板文件名称'"
            >
              <el-input
                v-model.trim="form.templateFileName"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('INDEX.create_date') || '创建时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginCreateDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endCreateDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('INDEX.form_label_modification_time') || '修改时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginModifyDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endModifyDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  templateStatusList: ['Y'],
}
export default {
  props: { templateStatus: { type: Array, default: () => [] } },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      const status =
        this.templateStatus && this.templateStatus.length
          ? this.templateStatus
          : this.form.templateStatusList
      this.$emit('query', {
        ...this.form,
        templateStatusList: status,
        templateStatus: status,
      })
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
